import {trigger, state, animate, style, transition} from '@angular/animations';

export function routerTransitionSlideToleft() {
    return slideToLeft();
}
export function routerTransitionDropFromTop() {
    return dropFromTop();
}
export function routerTransitionFadeIn() {
    return fadeIn();
}
export function routerTransitionSlideFromRight() {
    return slideToRight();
}

export function dropFromTop() {
    return trigger('routerTransition', [
        state('void', style({position: 'fixed', width: '100%'})),
        state('*', style({ width: '75%'})),
        transition(':enter', [
            style({transform: 'translateY(-100%)'}),
            animate('300ms ease-in-out', style({transform: 'translateX(0%)'}))
        ])
    ]);
}

export function fadeIn() {
    return trigger('routerTransition', [
        state('void', style({ opacity: 0 })),
        state('*', style({ opacity: 1 })),
        transition(':enter', [
            style({ opacity: 0 }),
            animate('300ms')
        ])
    ]);
}

export function slideToLeft() {
    return trigger('routerTransition', [
        state('void', style({position:'fixed'}) ),
        state('*', style({width:'100%'}) ),
        transition(':enter', [  // before 2.1: transition('void => *', [
            style({transform: 'translateX(100%)'}),
            animate('300ms ease-in-out', style({transform: 'translateX(0%)'}))
        ]),
    ]);
}

export function slideToRight() {
    return trigger('routerTransition', [
        state('void', style({position:'fixed'}) ),
        state('*', style({width:'100%'}) ),
        transition(':enter', [  // before 2.1: transition('void => *', [
            style({transform: 'translateX(-100%)'}),
            animate('300ms ease-in-out', style({transform: 'translateX(0%)'}))
        ]),
    ]);
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/animations/router.animations.ts